/**
 * Created by Ning Jiang on 2022-05-03.
 */

import {WinPresentationController} from "../WinPresentationController";
import {Serial} from "../../Serial";
import {SerialSymbolState} from "../../symbol/SerialSymbolConfig";
import {gsap} from "gsap";
import {ScatterSymbol} from "../../symbol/ScatterSymbol";
import {SerialSound} from "../../sound/SerialSound";
import {XWaysSymbol} from "../../symbol/XWaysSymbol";

export class ScatterToXWaysController extends WinPresentationController {

    constructor() {
        super("ScatterToXWaysController", false);
    }

    protected hasWin():boolean {
        return Serial.model.parsedGameData.scatterToxWaysTriggered;
    }

    protected async createWinAnimation():Promise<any> {
        const promises:Promise<any>[] = [];
        Serial.model.parsedGameData.scatterPositions.forEach((symId, reelId) => {
            if(symId < 0 || reelId < 1 || reelId > 3) {
                return;
            }
            const xWays = Serial.reels[reelId].createSymbol("X", reelId, SerialSymbolState.NORMAL);
            const oldSymbol = Serial.reels[reelId].replaceSymbol(xWays, symId - 2);
            oldSymbol.onRemove();

            const tl = gsap.timeline();
            tl.add([
                (<XWaysSymbol>xWays).playFromScatter(),
                xWays.showMultiplier(`+${(<ScatterSymbol>oldSymbol).attachedValue}`)
            ]);
            const promise = Promise.resolve(tl);
            promises.push(promise);
        });
        SerialSound.soundPlayer.playTrack({name : SerialSound.SCATTER_TO_XWAYS});

        await Promise.all(promises);
    }
}